import React from 'react';
import {
  Button
} from 'reactstrap'
import { withFirebase } from '../Firebase';

const SignOutButton = ({ firebase }: any) => (
  <Button
    className="btn-primary-custom"
    onClick={firebase.doSignOut}
    style={{ width: '100%', margin: 0 }}
  >
    Sign Out
</Button>
);

export default withFirebase(SignOutButton);